import script from "./CardSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./CardSlider.vue?vue&type=script&setup=true&lang=js"

import "./CardSlider.vue?vue&type=style&index=0&id=c3a6e93c&lang=scss&scoped=true"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist-eni-for-2022-hub-e-longform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3a6e93c"]])

export default __exports__